import { Form } from 'antd';
import { Rule } from 'antd/es/form';

import { InputPercent } from 'components';

const { useWatch, useFormInstance, Item } = Form;

export const ThresholdInput = ({
  name,
  rules,
  placeholder,
  dependencies,
}: {
  name: string;
  rules: Rule[]
  placeholder?: string
  dependencies?: string[]
}) => {
  const form = useFormInstance();
  const value = useWatch(name, form);
  const hasAutoCalculatedThresholds = useWatch('hasAutoCalculatedThresholds', form);

  return (
    <Item
      name={name}
      rules={hasAutoCalculatedThresholds ? [] : rules}
      className='mb-0'
      dependencies={dependencies}
    >
      <InputPercent
        min={0}
        max={100}
        step={0.01}
        value={value}
        className='w-full'
        disabled={hasAutoCalculatedThresholds}
        precision={2}
        placeholder={hasAutoCalculatedThresholds ? 'AUTO' : placeholder}
        onChange={(val) => {
          form.setFieldsValue({ [name]: val });
        }}
      />
    </Item>
  );
};
